import styled from 'styled-components';
import Box from '@mui/material/Box';

export const IndexParent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const IndexHeader = styled(Box)`
  display: flex;
  width: 100%;
  background-color: #ffffff;
  align-content: center;
  box-sizing: border-box;
  z-index: 1000;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.08),
    0px 1px 2px 0px rgba(0, 0, 0, 0.16);
`;

export const IndexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  flex: 1;

  @media (max-width: 1100px) {
    padding: 80px 0 0;
  }
`;

export const IndexChildContainer = styled(Box)`
  min-width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  border: 1px solid #dce4e8;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  min-height: 0;
`;

export const CreateUserButtonContainer = styled.div`
  display: flex;
  margin: auto;
  margin-right: 0;
  margin-left: auto;
`;
